export const LOCALE_PREFIX =
    'scenes.Gnosus.scenes.Portfolio.components.Toolbar.components.ToolbarDesks.Navigation.components.Link'
